"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportTemplateInput = instanceOfReportTemplateInput;
exports.ReportTemplateInputFromJSON = ReportTemplateInputFromJSON;
exports.ReportTemplateInputFromJSONTyped = ReportTemplateInputFromJSONTyped;
exports.ReportTemplateInputToJSON = ReportTemplateInputToJSON;
/**
 * Check if a given object implements the ReportTemplateInput interface.
 */
function instanceOfReportTemplateInput(value) {
    if (!('content' in value) || value['content'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    return true;
}
function ReportTemplateInputFromJSON(json) {
    return ReportTemplateInputFromJSONTyped(json, false);
}
function ReportTemplateInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'title': json['title'],
    };
}
function ReportTemplateInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'],
        'parent_id': value['parent_id'],
        'title': value['title'],
    };
}
